import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { AccessibilityConstants } from './accessibility.constants';

export class AccessibilityUtil {

	public static shouldShowDebug(): boolean {
		return localStorage.getItem(AccessibilityConstants.DEBUG_URL_PARAM) === 'true';
	}

	public static getDebugStyle(sanitizer: DomSanitizer, color: string): SafeStyle {
		if (AccessibilityUtil.shouldShowDebug()) {
			return sanitizer.bypassSecurityTrustStyle(`border: 2px solid ${color} !important`);
		}
		return null;
	}

}
